import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../env";

//  Fetch all hotels for dropdown
export const fetchHotels = createAsyncThunk(
  "hotelOcc/fetchHotels",
  async (userHotelId = null) => {
    const url = userHotelId
      ? `${REACT_APP_API_URL}api/dashboard/admin/hotel/${userHotelId}`
      : `${REACT_APP_API_URL}api/room-tariff/get-hotels`;

    const res = await axios.get(url);
    const hotels = Array.isArray(res.data.data)
      ? res.data.data
      : res.data.data
        ? [res.data.data]
        : [];

    const formatted = hotels.map((hotel) => ({
      value: hotel.PropertyID,
      label: hotel.UnitName || hotel.PropertyName,
    }));
    return formatted;
  }
);

// Fetch all hotels monthly summary
export const fetchAllHotelsSummary = createAsyncThunk(
  "hotelOcc/fetchAllHotelsSummary",
  async (year) => {
    const res = await axios.post(
      `${REACT_APP_API_URL}api/dashboard/admin/allhotels-monthly-occ`,
      { hotelId: 0, year }
    );
    return res.data.data || [];
  }
);

// Fetch single hotel summary
export const fetchHotelSummary = createAsyncThunk(
  "hotelOcc/fetchHotelSummary",
  async ({ hotelId, year }) => {
    const res = await axios.post(
      `${REACT_APP_API_URL}api/dashboard/admin/hotelwise-monthly-occupancy`,
      { hotelId, year }
    );
    return res.data.data || [];
  }
);

// Fetch single hotel details (month-wise)
export const fetchHotelDetails = createAsyncThunk(
  "hotelOcc/fetchHotelDetails",
  async ({ hotelId, year, month, pageNo, pageSize, recordsPerPage }) => {
    const res = await axios.post(
      `${REACT_APP_API_URL}api/dashboard/admin/single-hotel-monthly`,
      {
        hotelId,
        year,
        month,
        pageNo: pageNo || 1,
        recordsPerPage: pageSize || recordsPerPage 
      }
    );
    return {
      data:res.data.data,
      totalCount:res.data.totalCount
    };
   
  }
);

// --- Slice ---
const hotelOccupancySlice = createSlice({
  name: "hotelOcc",
  initialState: {
    currentView: "all", 
    hotelId: 0,
    year: new Date().getFullYear(),
    month: null,
    hotels: [], 
    allHotelsSummary: [],
    hotelSummary: [],
    hotelDetails: [],
    loading: false,
  },
  reducers: {
    setView: (state, action) => {
      state.currentView = action.payload;
    },
    setSelection: (state, action) => {
      const { hotelId, year, month } = action.payload;
      state.hotelId = hotelId;
      state.year = year;
      state.month = month || null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchHotels
      .addCase(fetchHotels.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchHotels.fulfilled, (state, action) => {
        state.loading = false;
        state.hotels = action.payload;
      })
      .addCase(fetchHotels.rejected, (state) => {
        state.loading = false;
        state.hotels = [];
      })

      // fetchAllHotelsSummary
      .addCase(fetchAllHotelsSummary.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllHotelsSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.allHotelsSummary = action.payload;
      })

      //  fetchHotelSummary
      .addCase(fetchHotelSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.hotelSummary = action.payload;
      })

      //  fetchHotelDetails
      .addCase(fetchHotelDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.hotelDetails = action.payload.data;
        state.totalCount = action.payload.totalCount;
      });
  },
});

export const { setView, setSelection } = hotelOccupancySlice.actions;
export default hotelOccupancySlice.reducer;
